// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { reorderPadFiltersStyles } from "@steiner/App/Widgets/ReorderPad/ReorderPadFilters";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

reorderPadFiltersStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};
reorderPadFiltersStyles.filtersGridContainer = {
    css: css`
        padding: 12px;
    `,
};
reorderPadFiltersStyles.clearFiltersButton = {
    variant: "secondary",
    sizeVariant: "small",
};

reorderPadFiltersStyles.filterButtonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
        column-gap: 12px;
        ${xScreen("lte", "sm")} {
            align-items: center;
        }
    `,
};
